// extracted by mini-css-extract-plugin
module.exports = {"base":"Navigation_base__28MQs","items":"Navigation_items__2au9d"};